var map = {
	"./flags/en.svg": 960,
	"./flags/es.svg": 961,
	"./flags/fr.svg": 962,
	"./flags/it.svg": 963,
	"./flags/nl.svg": 964,
	"./flags/pt.svg": 965,
	"./icons/icon-arrow-down.svg": 145,
	"./icons/icon-arrow-up.svg": 146,
	"./icons/icon-beach--green.svg": 966,
	"./icons/icon-beach--red.svg": 967,
	"./icons/icon-beach.svg": 968,
	"./icons/icon-break.svg": 969,
	"./icons/icon-chevron-circle-left.svg": 970,
	"./icons/icon-chevron-circle-right.svg": 971,
	"./icons/icon-info--circle.svg": 972,
	"./icons/icon-legend-buoys.svg": 973,
	"./icons/icon-legend-star.svg": 974,
	"./icons/icon-legend-swell-arrow.svg": 975,
	"./icons/icon-legend-swell.svg": 976,
	"./icons/icon-legend-wind.svg": 977,
	"./icons/icon-point--green.svg": 978,
	"./icons/icon-point--red.svg": 979,
	"./icons/icon-point.svg": 980,
	"./icons/icon-reef--green.svg": 981,
	"./icons/icon-reef--red.svg": 982,
	"./icons/icon-reef.svg": 983,
	"./icons/icon-river--green.svg": 984,
	"./icons/icon-river--red.svg": 985,
	"./icons/icon-river.svg": 986,
	"./icons/icon-sandbar--green.svg": 987,
	"./icons/icon-sandbar--red.svg": 988,
	"./icons/icon-sandbar.svg": 989,
	"./icons/icon-tidal-range--blue.svg": 990,
	"./icons/icon-tide-clock--color.svg": 991,
	"./icons/icon-tide-needle.svg": 992,
	"./icons/icon-tide-star.svg": 993,
	"./logos/apple-logo--black.svg": 994,
	"./logos/apple-logo--white.svg": 995,
	"./logos/google-g-logo.svg": 996,
	"./logos/outside-logo--black.svg": 997,
	"./logos/outside-logo--white.svg": 998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;